export default "__VITE_ASSET__CF23LaRI__"